export const
    setModalViewState: ICollectionInstanceModalViewStateActionCreator = (open, collectionInstanceId, name, description) => {
        return {
            type: ACTION_COLLECTION_INSTANCE_MODAL_VIEW_STATE,
            open,
            collectionInstanceId,
            name,
            description
        }
    }

export const
    ACTION_COLLECTION_INSTANCE_MODAL_VIEW_STATE = "ACTION_COLLECTION_INSTANCE_MODAL_VIEW_STATE"

/* Actions */

export interface ICollectionInstanceModalViewStateAction {
    type: "ACTION_COLLECTION_INSTANCE_MODAL_VIEW_STATE",
    open: boolean;
    collectionInstanceId: number;
    name: string;
    description: string;
}

/* Action Creators */

export interface ICollectionInstanceModalViewStateActionCreator {
    (
        open: boolean,
        collectionIntanceId: number,
        name: string,
        description: string
    ): ICollectionInstanceModalViewStateAction;
}



/* Final Export of actions */
export type CollectionInstanceModalPageAction =
    ICollectionInstanceModalViewStateAction;
